module.exports = __webpack_public_path__ + "static/media/process_small.86edbc99.jpg";